import { useMemo } from 'react';
import { TileTabsRow } from '@creditflowresearch/uilib/Tile';
import Tabs from '@/creditflowresearch/ui/common/components/Tabs';
import { useProductsContext } from '@/creditflowresearch/application/Deal/contexts/ProductsContext';

const TileTabs = (): React.ReactElement => {
  const { onProductChange, selectedTab, tabs } = useProductsContext();

  const tabsForComponent = useMemo(() =>
    tabs.map((tab) => ({
      name: tab.name,
      key: tab.id,
      isDisabled: false,
    })),
  [tabs],
  );

  const activeTabKey = selectedTab?.id || tabs[0]?.id;

  const handleTabSelect = (tabName: string): void => {
    const tab = tabs.find((t) => t.name === tabName);
    tab && onProductChange(tab.id);
  };

  return (
    <TileTabsRow dataTest="dealTileProductTabsRow" overlap={ false }>
      <Tabs
        tabs={ tabsForComponent }
        onSelect={ handleTabSelect }
        activeTab={ activeTabKey }
        dataTest="dealTileProductTabs"
      />
    </TileTabsRow>
  );
};

export default TileTabs;
